 import { Link } from "react-router-dom";
import "../../assets/css/eventexpo.css";
 
 function Expo(){
    return(
         <section className="Eventiconbox"> 
            <Link to="/" style={{ textDecoration:"none", color:"#000" }}> 
                  <i className="bi bi-calendar-check"></i><br/>Event
            </Link>   
         </section>
      )
 }
 export default Expo;